module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Restro","short_name":"Restro","start_url":"/","background_color":"#f9f8f7","theme_color":"#ff6d23","display":"minimal-ui","icon":"src/images/restaurant-favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"eb41ae665461996d4a0b57a2de271e4a"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
